import React, { useLayoutEffect } from 'react';
import { Col, Row, Space } from 'antd';
import numeral from 'numeral';
import { iconArray } from '../assets/icons/icons'
import themeColors from '../theme/colors';

const style = {
    listText: (type) => ({
        fontSize: type === 'title' ? '25px' : '34px',
        textShadow: type === 'title' ? 'rgb(0 0 0 / 25%) 1px 1px 3px' : 'none',
        fontWeight: type === 'title' ? 'bold' : 'normal',
    }),
    infoText: () => ({
        fontWeight: 'bold',
        fontSize: '14px'
    }),
    column: (showGridLines) => ({
        border: showGridLines ? '0.5px solid black' : 'none',
        // padding: '10px'
    })
}

const ListTable = ({
    columns,
    data,
    styleProps,
    renderedCharts,
    amchartId
}) => {

    useLayoutEffect(() => {
        renderedCharts.current[amchartId] = true
    }, []);

    // number formatter
    const numberFormatter = item => numeral(item).format("0,0");

    /**
     * @function setList
     * @returns {Array} list to be displayed based on the result set
     */
    const setList = () => {
        return columns.map((column, idx) => {
            return [
                iconArray(styleProps.iconColor)[idx],
                (column.shortTitle || column.title),
                numberFormatter(
                    data[0][column.dataIndex]
                )]
        })
    }

    return (
        <>
            <Space
                direction='vertical'
                size="middle"
            >
                <Space
                    direction="vertical"
                    size={5}
                    style={{ width: '100%' }}
                >
                    {setList().map((row, i) => (
                        <Row
                            align="middle"
                            justify="center"
                            gutter={[0, 0]}
                            style={{}}
                            key={i}
                        >
                            <Col span={6} />
                            <Col
                                span={2}
                                style={{
                                    padding: 0,
                                    ...style.column(styleProps.showGridLines),
                                }}
                            >
                                {row[0]}
                            </Col>
                            <Col
                                span={5}
                                style={{
                                    ...style.listText('title'),
                                    ...styleProps.header,
                                    ...style.column(styleProps.showGridLines),
                                }}
                            >
                                {row[1]}
                            </Col>
                            <Col
                                span={4}
                                style={{
                                    ...style.listText('value'),
                                    ...styleProps.data,
                                    // ...style.centerVertical(), 
                                    ...style.column(styleProps.showGridLines)
                                }}
                            >
                                {row[2]}
                            </Col>
                            <Col span={5} />
                        </Row>
                    ))}
                </Space>
                <Row gutter={[0, 40]} justify='center'>
                    <Col span={7} />
                    <Col span={12}>
                        <p style={style.infoText()}>
                            The process of calculating potential views is done automatically through the system
                            via the data provided by research companies specialized in evaluating the levels of online
                            websites and the number of visitors.
                        </p>
                    </Col>
                    <Col span={5} />
                </Row>
            </Space>
        </>
    )
}

ListTable.defaultProps = {
    styleProps: {
        headerColor: themeColors.BLACK,
        dataColor: themeColors.BLACK,
        iconColor: themeColors.BLACK,
    }
}

export default ListTable